import { getPersons, PersonBookProvider } from 'entities/person';
import { PaginationFilterProvider } from 'shared/ui/pagination';
import { DashboardContainer } from 'widgets/dashboardContainer';
import { PersonFilterPanel } from 'widgets/personFilterPanel';
import { PersonList } from './personList';
import { Booking } from 'widgets/booking';
import { OrderInfoProvider } from 'entities/orders';
import { Flex } from 'shared/ui/flex';
import { ModalProvider } from 'shared/ui/modal';
import { PersonModalEdit } from 'widgets/personModalCard/ui/personModalEdit';

export const ContactBook = () => {
	return (
		<PaginationFilterProvider fetchData={getPersons}>
			<DashboardContainer>
				<OrderInfoProvider>
					<PersonBookProvider>
						<Booking
							resetPersonAfterClose={false}
							usePersonBookProvider={false}
						/>
            <Flex
              $margin='0 25px 20px'
              $gap='20px'
            >
              <ModalProvider>
                <PersonModalEdit
                  updatePersonBook={false}
                  updateOrder={'none'}
                  headerContent="Создание нового гостя"
                  isCreate={true}
                />
              </ModalProvider>
						  <PersonFilterPanel />
            </Flex>
						<PersonList />
					</PersonBookProvider>
				</OrderInfoProvider>
			</DashboardContainer>
		</PaginationFilterProvider>
	);
};
